


export const progressReducer = (state = window.OPSEEKER_CONFIG.INITIAL_PROGRESS ? window.OPSEEKER_CONFIG.INITIAL_PROGRESS : 0, action) => {
    if (action.type !== 'UPDATE_PROGRESS') return state;
    else return parseInt(action.payload)
}